module.exports = __webpack_public_path__ + "static/media/attachFile.5d6a215e.svg";